import { render, staticRenderFns } from "./classdetailsManage.vue?vue&type=template&id=5bb594bc&scoped=true"
import script from "./classdetailsManage.vue?vue&type=script&lang=js"
export * from "./classdetailsManage.vue?vue&type=script&lang=js"
import style0 from "./classdetailsManage.vue?vue&type=style&index=0&id=5bb594bc&prod&lang=less&scoped=true"
import style1 from "./classdetailsManage.vue?vue&type=style&index=1&id=5bb594bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb594bc",
  null
  
)

export default component.exports